function scrollTrackByCard( track, cardSelector, direction )
{
    var card = track.querySelector( cardSelector );
    var gap  = parseFloat( getComputedStyle( track ).columnGap );

    if ( card )
    {
        track.scrollBy( { left: direction * ( card.offsetWidth + gap ), behavior: "smooth" } );
    }
}

function applyQuizResumeVariant( section, linkSelector )
{
    if ( section )
    {
        var link = section.querySelector( linkSelector );

        // Quiz helpers come from my-aisle-quiz-resume-banner.js (loaded in theme.liquid).
        if (
            link
            && ( section.getAttribute( "data-variant" ) == "B" || section.getAttribute( "data-variant" ) == "C" )
            && window.safeStorageGet
            && window.quizResumeSlideHref
            && window.safeStorageGet( "welleasy_onboarding_quiz_state" )
        )
        {
            link.setAttribute( "href", window.quizResumeSlideHref() );
        }
    }
}
